The position profile that the history item relates to.

This is null for interactions that are not specific to an individual position,
such as a general interview with a recruiter.
